module.exports = __webpack_public_path__ + "e0106718/img/rename-icon.de4e673d.svg";